var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".custom_dnb_status_svg__cls-1{fill:none;stroke:#b3b3b3;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom_dnb_status_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "custom_dnb_status_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_status_svg__cls-1",
    d: "M18 35.5A17.5 17.5 0 10.5 18 17.49 17.49 0 0018 35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_status_svg__cls-1",
    d: "M3.54 20.28h3.62c3.35 0 3.06-2.84 5.52-14.65a.75.75 0 01.32-.44.76.76 0 01.43-.19.78.78 0 01.48.17.69.69 0 01.26.44l4.66 22.72a.8.8 0 00.26.43.76.76 0 001 0 .82.82 0 00.27-.43L23.53 15a.71.71 0 01.25-.4.69.69 0 01.43-.18.81.81 0 01.46.11.8.8 0 01.31.37c1.13 2.82 1.58 5.38 4.21 5.38h3.27"
  })))));
}

export default SvgCustomDnbStatus;